import React, { PureComponent, RefObject, createRef } from 'react';

import { UrlMetadata } from 'api';
import { EmbedPlaceholder, EmbedWrapper } from './index';

interface IProps {
  url: UrlMetadata['url'];
}

interface IState {
  loaded: boolean;
}

class EmbedFacebook extends PureComponent<IProps> {
  container: RefObject<HTMLDivElement>;

  state: IState = {
    loaded: false,
  };

  constructor(props: IProps) {
    super(props);
    this.container = createRef();
  }

  componentDidMount() {
    const { current } = this.container;
    window?.FB?.XFBML?.parse(current, this.onLoaded);
  }

  onLoaded = () => {
    this.setState({ loaded: true });
  };

  render() {
    const { url } = this.props;
    const { loaded } = this.state;

    return (
      <div>
        {!loaded && <EmbedPlaceholder />}
        <EmbedWrapper visible={loaded}>
          <div ref={this.container}>
            <div className="fb-post" data-href={url} />
          </div>
        </EmbedWrapper>
      </div>
    );
  }
}

export default EmbedFacebook;
